
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta } from "/app/pages/login.vue?macro=true";
import { default as step0GYloEtSLFXNF_mg8SoGkUCnx6uOWm8nnivlTC0CD_45T8Meta } from "/app/pages/step0.vue?macro=true";
import { default as logoutUcooZuBFq6Y_45qkSHe3Slgw7Ozl4rsMv5kY96MDZ8icoMeta } from "/app/pages/logout.vue?macro=true";
import { default as linkAccountOa_ERAeMkb13_45YSlJyOP7ssRAqVueLSPdbiwwF_gAy0Meta } from "/app/pages/linkAccount.vue?macro=true";
import { default as setPasswordvm_4555czFu2VSBZ5IXKtGWgLzX_45DeGTz_455aV3jMdMWxkMeta } from "/app/pages/setPassword.vue?macro=true";
import { default as registrationLiA78_aRyKlOT0_45_45o8Ng6OrjiK0yuJmNMrHZ46zSKqIMeta } from "/app/pages/registration.vue?macro=true";
import { default as codeValidationmimPHnBKjOjGNzuxWrl8_45HJCN3mDcKci4F7qz_459xxSEMeta } from "/app/pages/codeValidation.vue?macro=true";
import { default as forgotPasswordDUN6BGbXm5oHGRUNEEPz2sjVwv9od1_ohSuKRy7YfOEMeta } from "/app/pages/forgotPassword.vue?macro=true";
import { default as verifyIdentityjaGzy8uTrCpgg88MI_45U_BKY8wY4_5ueivKV6vDLv9aYMeta } from "/app/pages/verifyIdentity.vue?macro=true";
import { default as addProfilePicture9rkHfZoyFlSRL0Lii7qiOgh_CP1dF38f8HNlfm9HbH4Meta } from "/app/pages/addProfilePicture.vue?macro=true";
import { default as termsAndConditions4pig9K7NalNZdNZKJ3DPmiwqDPI4zIsc8lfYOmxtEDUMeta } from "/app/pages/termsAndConditions.vue?macro=true";
import { default as confirmPublicationsDnW66SBu0RtrKmd20690SXT5LkIF9SC0_30fdqbh0AEMeta } from "/app/pages/confirmPublications.vue?macro=true";
import { default as confirmInformationContinueporaOyjW_45U4KGeugAOM5N_451Do2nyOTG4OZNaWk7PqEAMeta } from "/app/pages/confirmInformationContinue.vue?macro=true";
import { default as resetPasswordCodeValidationGMZExbsp0e4ZBWB_45gDljIYe8yo7gy6Eh3xJNJlIKBgIMeta } from "/app/pages/resetPasswordCodeValidation.vue?macro=true";
import { default as legacySecondaryEmailComplete9Q333fVIJ6w79GwOWVkqBG7UczT4J0WCBhxTscp6H9UMeta } from "/app/pages/legacySecondaryEmailComplete.vue?macro=true";
import { default as institutionalEmailConfirmationNNOYzxNFgnArKIO7T2IpJdtx1m3S8TqBAG8qbJzZzukMeta } from "/app/pages/institutionalEmailConfirmation.vue?macro=true";
import { default as institutionalEmailCodeValidationRkPlD9skHOh4Nx0O_QLwNcVisJ_45tbpeIR2Y1fUZNKGAMeta } from "/app/pages/institutionalEmailCodeValidation.vue?macro=true";
export default [
  {
    name: "login",
    path: "/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    alias: ["/people/login"],
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "register",
    path: "/step0",
    meta: step0GYloEtSLFXNF_mg8SoGkUCnx6uOWm8nnivlTC0CD_45T8Meta || {},
    alias: ["/register"],
    component: () => import("/app/pages/step0.vue")
  },
  {
    name: "logout",
    path: "/logout",
    meta: logoutUcooZuBFq6Y_45qkSHe3Slgw7Ozl4rsMv5kY96MDZ8icoMeta || {},
    alias: ["/people/logout"],
    component: () => import("/app/pages/logout.vue")
  },
  {
    name: "link-account",
    path: "/linkAccount",
    meta: linkAccountOa_ERAeMkb13_45YSlJyOP7ssRAqVueLSPdbiwwF_gAy0Meta || {},
    alias: ["/register/link-account"],
    component: () => import("/app/pages/linkAccount.vue")
  },
  {
    name: "set-password",
    path: "/setPassword",
    meta: setPasswordvm_4555czFu2VSBZ5IXKtGWgLzX_45DeGTz_455aV3jMdMWxkMeta || {},
    alias: ["/password/set-password"],
    component: () => import("/app/pages/setPassword.vue")
  },
  {
    name: "step-1",
    path: "/registration",
    meta: registrationLiA78_aRyKlOT0_45_45o8Ng6OrjiK0yuJmNMrHZ46zSKqIMeta || {},
    alias: ["/register/step-1"],
    component: () => import("/app/pages/registration.vue")
  },
  {
    name: "code-validation",
    path: "/codeValidation",
    meta: codeValidationmimPHnBKjOjGNzuxWrl8_45HJCN3mDcKci4F7qz_459xxSEMeta || {},
    alias: ["/register/code-validation"],
    component: () => import("/app/pages/codeValidation.vue")
  },
  {
    name: "forgot",
    path: "/forgotPassword",
    meta: forgotPasswordDUN6BGbXm5oHGRUNEEPz2sjVwv9od1_ohSuKRy7YfOEMeta || {},
    alias: ["/password/forgot"],
    component: () => import("/app/pages/forgotPassword.vue")
  },
  {
    name: "research-accounts",
    path: "/verifyIdentity",
    meta: verifyIdentityjaGzy8uTrCpgg88MI_45U_BKY8wY4_5ueivKV6vDLv9aYMeta || {},
    alias: ["/register/research-accounts"],
    component: () => import("/app/pages/verifyIdentity.vue")
  },
  {
    name: "profile-picture",
    path: "/addProfilePicture",
    meta: addProfilePicture9rkHfZoyFlSRL0Lii7qiOgh_CP1dF38f8HNlfm9HbH4Meta || {},
    alias: ["/register/profile-picture"],
    component: () => import("/app/pages/addProfilePicture.vue")
  },
  {
    name: "terms-and-conditions",
    path: "/termsAndConditions",
    meta: termsAndConditions4pig9K7NalNZdNZKJ3DPmiwqDPI4zIsc8lfYOmxtEDUMeta || {},
    alias: ["/legal/terms-and-conditions","/terms-and-conditions","/legal/privacy-policy","/legal/copyright-statement","/legal/cookie-policy","/legal/summary-of-changes","/legal/events-terms-and-conditions"],
    component: () => import("/app/pages/termsAndConditions.vue")
  },
  {
    name: "confirm-publications",
    path: "/confirmPublications",
    meta: confirmPublicationsDnW66SBu0RtrKmd20690SXT5LkIF9SC0_30fdqbh0AEMeta || {},
    alias: ["/register/confirm-publications"],
    component: () => import("/app/pages/confirmPublications.vue")
  },
  {
    name: "request",
    path: "/confirmInformationContinue",
    meta: confirmInformationContinueporaOyjW_45U4KGeugAOM5N_451Do2nyOTG4OZNaWk7PqEAMeta || {},
    alias: ["/auth/request"],
    component: () => import("/app/pages/confirmInformationContinue.vue")
  },
  {
    name: "reset-code-validation",
    path: "/resetPasswordCodeValidation",
    meta: resetPasswordCodeValidationGMZExbsp0e4ZBWB_45gDljIYe8yo7gy6Eh3xJNJlIKBgIMeta || {},
    alias: ["/password/reset-code-validation"],
    component: () => import("/app/pages/resetPasswordCodeValidation.vue")
  },
  {
    name: "CompleteSecondaryEmail",
    path: "/legacySecondaryEmailComplete",
    meta: legacySecondaryEmailComplete9Q333fVIJ6w79GwOWVkqBG7UczT4J0WCBhxTscp6H9UMeta || {},
    alias: ["/email/verify"],
    component: () => import("/app/pages/legacySecondaryEmailComplete.vue")
  },
  {
    name: "ie-confirmation",
    path: "/institutionalEmailConfirmation",
    meta: institutionalEmailConfirmationNNOYzxNFgnArKIO7T2IpJdtx1m3S8TqBAG8qbJzZzukMeta || {},
    alias: ["/register/ie-confirmation"],
    component: () => import("/app/pages/institutionalEmailConfirmation.vue")
  },
  {
    name: "ie-code-validation",
    path: "/institutionalEmailCodeValidation",
    meta: institutionalEmailCodeValidationRkPlD9skHOh4Nx0O_QLwNcVisJ_45tbpeIR2Y1fUZNKGAMeta || {},
    alias: ["/register/ie-code-validation"],
    component: () => import("/app/pages/institutionalEmailCodeValidation.vue")
  }
]